<template>
    <ui-crud title="Global Specs" subtitle="Build specs that are made up of materials and labour rates." :fetch="fetch"
             groupBy="nbs" :pipe-with="pipeItems">

        <!-- Filters. -->
        <template #filters>
            <ui-select class="mt-6" name="filter" v-model="activeFilter" :options="filterables"></ui-select>
            <div class="relative">
                <ui-input class="mt-6" field="bg-gray-50 pr-10" name="search" v-model="search"></ui-input>
                <div class="absolute right-0 inset-y-0 h-full flex items-center justify-center p-3 text-gray-400">
                    <i class="fas fa-search"></i>
                </div>
            </div>
        </template>

        <!-- List item. -->
        <template #list-item="{ item, select, active }">
            <ui-crud-card
                :title="item.title"
                :subtitle="[`${$options.filters.toCurrency(item.cost_per_uom)} Per ${item.unit_of_measure}`]"
                :active="active"
                @click="select()"
            >
                <div v-if="!item.approved" class="text-sm text-yellow-600">Unapproved</div>
            </ui-crud-card>
        </template>

        <!-- Create form. -->
        <template #create="{ addItem }">
            <global-specs-form :add-item="addItem"/>
        </template>

        <!-- Edit form. -->
        <template #edit="{ selectedItem, setEditMode }">
            <global-specs-form :edit="setEditMode" :item="selectedItem"/>
        </template>

        <!-- Show page. -->
        <template #show="{ selectedItem, setEditMode, removeItem, showCreateButton, createNew }">
            <global-specs-show :can-approve="canApprove" :edit="setEditMode" :item="selectedItem"
                               :new-action="createNew" :removeItem="removeItem" :show-new-action="showCreateButton"/>
        </template>
    </ui-crud>
</template>

<script>
import {GlobalSpec} from '@models'

export default {
    data() {
        return {
            activeFilter: 'all',
            filterables: [
                {value: 'all', label: 'All'},
                {value: 'unapproved', label: 'Unapproved'},
                {value: 'approved', label: 'Approved'},
            ],
            search: '',
        }
    },
    props: {
        canApprove: Boolean,
    },
    methods: {
        async fetch() {
            return await GlobalSpec.all();
            if (this.specs.length === 0) {
                this.specs = await GlobalSpec.all();
            }
            const query = this.search.toLowerCase().split(/[^A-Za-z0-9.-]+/);
            if (query.length) {
                return this.specs.filter((spec) => {
                    return query.every((token) => {
                        return spec.tokens.includes(token);
                    })
                });
            }
            return this.specs;

            return this.specs.filter()
        },
        pipeItems(items) {
            let specs = items;
            if (this.activeFilter !== 'all') {
                const approved = this.activeFilter === 'approved'
                specs = specs.filter(item => item.approved === approved)
            }
            const query = this.search.toLowerCase().split(/[^A-Za-z0-9.-]+/);
            if (query.length) {
                specs = specs.filter((spec) => {
                    return query.every((token) => {
                        return spec.tokens.includes(token);
                    })
                });
            }
            return specs;
        },
    },
}
</script>
